'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import UICheckbox from 'UIComponents/input/UICheckbox';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';

const AdAccountCheckbox = ({
  children,
  checked,
  accountDisabled,
  currentUserHasConnected,
  onChange,
  alreadyConnected,
  accountLimitMet,
  maxSelectableAccounts
}) => {
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: !currentUserHasConnected && (!accountLimitMet || checked),
    title: currentUserHasConnected ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.youAlreadyConnected"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.limits.tooltip",
      options: {
        count: maxSelectableAccounts
      }
    }),
    children: /*#__PURE__*/_jsx(UICheckbox, {
      checked: checked,
      onChange: onChange,
      disabled: accountDisabled || currentUserHasConnected || accountLimitMet && !alreadyConnected && !checked,
      alignment: "center",
      name: "adAccountSelect",
      children: children
    })
  });
};

export default AdAccountCheckbox;